angular.module('zc.projects')

.directive 'zcCampaignSegmentShow', (CampaignSegment, Devise, titlesBySegmentType) ->
  restrict: 'E'
  templateUrl: "/templates/projects.segments/campaign_segment_show.html"
  replace: true
  scope:
    project: "="
    segmentId: "="
  link: (scope, element, attrs) ->
    scope.Devise = Devise
    scope.detailsVisible = false

    CampaignSegment.get(scope.project.id, scope.segmentId)
    .then (res) ->
      scope.segment = res

    scope.getPageTitle = (segment_type) ->
      return titlesBySegmentType[segment_type]

    scope.getTemplateUrl = () ->
      return if !scope.segment
      type = switch scope.segment.segment_type
        when 'custom_old'
          'custom'
        else
          scope.segment.segment_type
      "/templates/projects.segments/campaign_segment_show_#{type}.html"




// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.segments/campaign_segment_show.directive.coffee